export default __webpack_public_path__ + "static/media/sendMessageErrorIcon.27b6ba37.svg";